<template>
    <div class="profile-board test-editor-ssp">
        <h2 v-if="(loading.results || loading.candidate)">Загрузка...</h2>
        <h2 v-else-if="!res">Тест не завершен</h2>

        <div v-else class="row mt-2 mt-md-8">
            <div class="col-12 col-md-8 pa-3">
                <h3 class="rep-test-title">{{ testData.name }}</h3>

                <div class="test-description">
                    <h4 class="desc-title">{{ testData.test_results_title ? testData.test_results_title : '' }} </h4>
                    <p v-if="testData.test_results_description" v-html="sanitizeRichHtml(testData.test_results_description)"></p>
                </div>
                <hr class="mt-4 mb-6 color-gray">

                <div v-for="(prof, indProf) in positions(testData)" :key="indProf+1000" class="ssp-item">
                    <div class="d-flex">
                        <Scale10ColorLineBlocksCompitence :lineData="prof" />
                        <div class="ssp-item-block-legend">{{ prof.block ? prof.block.title : "Без названия" }}</div>
                    </div>
                </div>
                <hr class="mt-9 mb-6 color-gray">

                <!-- <h3 class="rep-test-title">Описание и рекомендации</h3> -->
                <v-expansion-panels v-model="showPanels" multiple>
                    <v-expansion-panel class="accordion" v-for="(prof, indProf) in positions(testData)" :key="indProf"
                        :style="{ '--before-color': getProfColor(prof)}">
                        <v-expansion-panel-header>
                            <div class="ssp-item-title-accordion triangle-right _bottom-green">
                                {{ prof.block ? prof.block.title : "Без названия" }}
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div class="ssp-item-text" v-html="sanitizeRichHtml(prof.block ? prof.block.description : '')" />
                            <div class="ssp-item-text" v-html="sanitizeRichHtml(prof.text)" />
                            <div class="ssp-item-subtitle triangle-right bottom-green">
                                Рекомендации
                            </div>
                            <template v-if="prof.recommendation">
                                <div class="desc-item-text" v-html="sanitizeRichHtml(prof.recommendation)" />
                            </template>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Scale10ColorLineBlocksCompitence from './Scale10ColorLineBlocksCOMPITENCE.vue';
import { sanitizeRichHtml } from '@/common/util';
import { mapGetters } from 'vuex';

export default {
    components: {
      Scale10ColorLineBlocksCompitence
    },
    data() {
        return {
            showPanels: 0,
            limit1: 39,
            limit2: 60,
        };
    },
    props: ['testCode'],
    computed: {
        ...mapGetters({
            user: 'auth/user',
            res: 'users/candidate/results',
            loading: 'users/candidate/loading',
            loadingCandidate: 'users/candidate/loading',
        }),
        testData() {
            return this.res?.constructor_test_results && this.res.constructor_test_results[this.testCode]
                ? this.res.constructor_test_results[this.testCode]
                : { name: "Отчет не найден", blocks: [] }
        },
        candidateId() {
            return this.user.user_type === CANDIDATE ? this.user.id : this.$route.params.id;
        },
    },
    methods: {
        sanitizeRichHtml,
        positions(testData) {
            const arr = [...testData.blocks]
            arr.sort((a, b) => b?.value - a?.value)
            return arr
        },
        getProfValue(item) {
            let v = Math.round(item.value)
            return v
        },
        getProfColor(item) {
            const interval = item.intervals.find(el => el.id === item.matched_interval);
            return interval ? interval.color : '#39A9DC'
        },
    },
};
</script>

<style lang="scss">
@import "src/assets/styles/variables";

.test-editor-ssp {

.color-gray {
  color: #A2A2A2;
  border-color: #A2A2A2;
}

.test-description {
  background: var(--color-bg);
  padding: 20px 10px 10px 20px;
  margin: 20px 0;
  border-radius: 5px;
}

.ssp-item-block-legend {
  font-size: 16px;
  font-weight: 600;
  margin: 40px 0 0px 20px;
}

.ssp-item-title {
  font-size: 22px;
  font-weight: 600;
  margin: 50px 0 30px 0;
}
.ssp-item-title-accordion {
  font-size: 24px;
  font-weight: 600;
  margin: 10px 0 10px 0;

}


.ssp-item-subtitle, .ssp-item-text h2 {
  margin: 30px 0 30px 0;
  font-size: 18px;
  font-weight: 600;
}

.triangle-right, .ssp-item-text h2{
  display: flex;
  align-items: center;
}

.triangle-right::before, .ssp-item-text h2::before {
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 10px solid var(--before-color);
  margin-right: 10px;
  content: '';
}

.bottom-green, .ssp-item-text h2 {
  position: relative;
}

.bottom-green::after, .ssp-item-text h2::after {
  position: absolute;
  bottom: -10px;
  left: 20px;
  width: 120px;
  height: 2px;
  background: var(--before-color);
  opacity: 0.3;
  content: '';
}

@media screen and (max-width: 600px) {
  .ssp-item-block-legend {
      margin: 35px 0 0px 10px;
      font-size: 12px;
  }
}

}
</style>
